const ProgressBar = ({totalSteps,currentStep}) => {
  const progress = (currentStep / totalSteps) * 100; // Calculate percentage

  return (
    <div className="progress" style={{ height: "24px",background:"transparent" }}>
      <div
        className="progress-bar bg-progress fs-5"
        role="progressbar"
        style={{ width: `${progress}%` }}
        aria-valuenow={progress}
        aria-valuemin={0}
        aria-valuemax={100}
      >{Math.round(progress)}%
</div>
    </div>
  );
};

export default ProgressBar;
